import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '../../auth/user-auth.service';
import { UserService } from '../../components/user/user.service';
import { CommonService } from '../../services/common.service'; 
import { AdmingeneralcompanyComponent } from 'src/app/components/admin/admingeneralcompany/admingeneralcompany.component';
import { User } from 'src/app/components/user/model/user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
 
  constructor(
    private oc_router: Router,
    public oc_commonService: CommonService,
    private oc_userService: UserService,
    public oc_userAuthService: UserAuthService 
  ) {}
 
  ngOnInit(): void { 
    
  }

  fn_navigateToLogout() { 
  }

  fn_toggleFilter() {
    this.oc_commonService.slideEmitter.emit();
  }

  fn_logout() {
    const userAuth = this.oc_userAuthService.load();
    if (userAuth == null) return;
    this.oc_userService.logout();
    this.oc_userAuthService.clear();
    this.oc_router.navigateByUrl('/login');
  }

  fn_showAccountSetting() {
    localStorage.setItem("callConfigAdmin","1");
    var vRole_id = JSON.parse(localStorage.userData).role;
    // console.log(vRole_id);
    // if (vRole_id == 6) {
    //   this.oc_router.navigateByUrl('/account-setting/admin');
    // }
    // else {
    this.oc_router.navigateByUrl('/account-setting');
    // }
  }

  fn_navigateToHome() {
    var user = JSON.parse(localStorage.getItem('userData'));
    const url = this.getRedirectUrlForUser(user);

    if (typeof url === 'string') {
      this.oc_router.navigateByUrl(url);
    } else {
      this.oc_router.navigate(url.path, { queryParams: url.queryParams });
    }
  }

  private getRedirectUrlForUser(user: any): string | { path: any[], queryParams: any } {
    const auth = this.oc_userAuthService;

    if (auth.isAdmin()) {
      return '/admin';
    }

    if (auth.isPatient()) {
      return { path: ['/records'], queryParams: { docNumber: user.docNumber } };
    }

    if (auth.isMedical() || auth.isLab() || auth.isAdmissionsClerk()) {
      return '/records';
    }

    return '/'; // fallback
  }
}
 

